'use client';

import { c as _c } from "react/compiler-runtime";
import { CalendarDate } from '@internationalized/date';
import { useField } from 'formik';
import type { DateValue } from 'react-aria-components';
import { DatePickerDesktop, DatePickerMobile } from './DatePicker';
type FormikDatePickerProps = {
  name: string;
  label?: string;
  isRequired?: boolean;
  minValue: DateValue;
  maxValue: DateValue;
};
const FormikDatePicker = t0 => {
  const $ = _c(17);
  const {
    name,
    label,
    isRequired,
    minValue,
    maxValue
  } = t0;
  const [, meta, helpers] = useField(name);
  let t1;
  if ($[0] !== meta.value) {
    t1 = meta.value ? new CalendarDate(meta.value.getFullYear(), meta.value.getMonth() + 1, meta.value.getDate()) : null;
    $[0] = meta.value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  let t3;
  if ($[2] !== helpers) {
    t2 = calendarDate => {
      const jsDate = calendarDate ? new Date((calendarDate as CalendarDate).year, (calendarDate as CalendarDate).month - 1, (calendarDate as CalendarDate).day) : null;
      helpers.setValue(jsDate);
    };
    t3 = () => helpers.setTouched(true);
    $[2] = helpers;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = meta.touched && !!meta.error;
  const t5 = meta.touched && meta.error ? meta.error : undefined;
  let t6;
  if ($[5] !== isRequired || $[6] !== label || $[7] !== maxValue || $[8] !== minValue || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== value) {
    t6 = {
      label,
      isRequired,
      value,
      onChange: t2,
      onBlur: t3,
      isInvalid: t4,
      errorMessage: t5,
      minValue,
      maxValue,
      allowDirectInput: true,
      showMonthYearDropdowns: true,
      fullWidth: true,
      labelInside: false
    };
    $[5] = isRequired;
    $[6] = label;
    $[7] = maxValue;
    $[8] = minValue;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const sharedProps = t6;
  let t7;
  if ($[15] !== sharedProps) {
    t7 = <><DatePickerDesktop {...sharedProps} /><DatePickerMobile {...sharedProps} /></>;
    $[15] = sharedProps;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export { FormikDatePicker };
export type { FormikDatePickerProps };